export default function About() {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
      <div className="eyebrow mb-3">ABOUT ALTCOINSMONEY</div>
      <h1 className="font-display text-5xl lg:text-6xl font-bold tracking-tight">
        A presale that <span className="text-gradient">rewards advocates</span>
      </h1>

      <div className="mt-10 space-y-6 text-lg text-ink-700 leading-relaxed">
        <p>
          AltCoinsMoney is the $AIML token presale on Polygon. The token is the unit of
          account for an upcoming AI-and-crypto product, but more importantly for this
          phase, it's the vehicle for the most aligned early-investor community we can
          build.
        </p>
        <p>
          The plan is simple: people who bring others — friends, audiences, network —
          get rewarded immediately in USDT and over time in AIML. No locks, no APY
          fiction, no MLM tiers. One layer, flat 20%, paid as you go.
        </p>
        <p>
          The AIML bonus pool is capped at 1% of the total supply (1 billion tokens
          out of 99 billion) and gets distributed transparently based on volume,
          milestones, weekly leaderboards, and consistency streaks. Every bonus is
          tracked off-chain and vested linearly over six months from token generation
          event.
        </p>
        <p>
          Withdrawals require KYC. This isn't because we want to. It's because shipping
          a real presale with real money attached requires a real anti-abuse line.
        </p>
      </div>

      <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="card-base p-6">
          <div className="eyebrow mb-2">NETWORK</div>
          <div className="font-display text-2xl font-semibold">Polygon (Matic)</div>
          <p className="text-sm text-ink-600 mt-2">
            Low fees, fast finality, EVM-compatible — matches the audience we're going
            after.
          </p>
        </div>
        <div className="card-base p-6">
          <div className="eyebrow mb-2">PAYMENT</div>
          <div className="font-display text-2xl font-semibold">USDT only</div>
          <p className="text-sm text-ink-600 mt-2">
            One stable input, one stable output. Commissions paid back in USDT.
          </p>
        </div>
        <div className="card-base p-6">
          <div className="eyebrow mb-2">TOTAL SUPPLY</div>
          <div className="font-display text-2xl font-semibold tabular-nums">99,000,000,000</div>
          <p className="text-sm text-ink-600 mt-2">AIML, ERC-20 standard, no mint after TGE.</p>
        </div>
        <div className="card-base p-6">
          <div className="eyebrow mb-2">BONUS POOL</div>
          <div className="font-display text-2xl font-semibold tabular-nums">1,000,000,000</div>
          <p className="text-sm text-ink-600 mt-2">
            AIML allocated for referrer rewards — about 1% of total supply.
          </p>
        </div>
      </div>
    </div>
  );
}
